import React from "react";
import { Megaphone, X, Wrench } from "lucide-react";
import { SEVERITY, fmt } from "./annUtil";
import { safeUrl } from "../../lib/safeUrl";

export default function BannerPreview({ a }) {
  const s = SEVERITY[a.severity] || SEVERITY.info;
  const Icon = a.kind === "maintenance" ? Wrench : Megaphone;
  const href = safeUrl(a.link);
  const win = a.maintenance?.start_at && `${fmt(a.maintenance.start_at)} – ${fmt(a.maintenance.end_at)}`;
  return (
    <div className={`flex items-start gap-3 rounded-xl border px-4 py-3 ${s.banner}`} data-testid="ann-banner-preview">
      <Icon size={16} className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold">{a.title || "Judul pengumuman"}</p>
        {a.body && <p className="mt-0.5 whitespace-pre-line text-xs opacity-90">{a.body}</p>}
        {win && <p className="mt-1 text-[11px] font-semibold">Jadwal: {win}</p>}
        {href && <a href={href} target="_blank" rel="noreferrer" className="mt-2 inline-block rounded-lg bg-white/70 px-2.5 py-1 text-[11px] font-bold underline-offset-2 hover:underline">{a.cta_label || "Selengkapnya"}</a>}
      </div>
      {a.dismissible && <X size={14} className="shrink-0 opacity-60" />}
    </div>
  );
}
